import React from 'react';

import { IoMdClose } from 'react-icons/io';
import { CellContainer } from '../styles';

const RemoveCell = ({ data, modalHook, setSelected }) => {
  const handleDelete = (event) => {
    event.stopPropagation();
    setSelected(data);
    modalHook.open();
  };

  return (
    <CellContainer travelOutside>
      <button
        type="button"
        onClick={handleDelete}
        title="Remover registro"
        aria-label="Remover registro"
        style={{
          border: 'none',
          background: 'transparent',
          padding: 0,
          margin: 0,
          lineHeight: 1,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          color: '#334155',
        }}
      >
        {IoMdClose ? <IoMdClose size={18} /> : 'x'}
      </button>
    </CellContainer>
  );
};

export default RemoveCell;
